module.exports = __webpack_public_path__ + "img/204.7bd8514b.gif";